import React, { useEffect, useRef } from 'react';

interface IProps {
  code: any;
}

const Intercom = (props: IProps): any => {
    const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
     if (!ref.current) return null;
    const script = document.createElement('script');
    (window as any).intercomSettings = { app_id: props.code };
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://widget.intercom.io/widget/${props.code}`;
    ref.current.appendChild(script);

    return () => {
      [
        'intercom-css-container',
        'intercom-frame',
        'intercom-container',
        'intercom-css-container'
      ].forEach(id => {
        const node = document.getElementById(id);
        node?.parentNode.removeChild(node);
      })
      const nodes = document.getElementsByClassName('intercom-lightweight-app');
      for (let i = 0; i < nodes.length; i++) {
        nodes[i]?.parentNode.removeChild(nodes[i]);
      }
      Object.keys(window)
        .filter(key => (key.toLocaleLowerCase()).includes('intercom'))
        .forEach(key => delete (window as any)[key]);
    }
  }, [props.code])

  return (
    <div ref={ref} />
  );
}

export default Intercom
